export function getCurrentDate(separator = "") {
    let newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${
        month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
}

export function recalculateItem(item, conditionIgv) {
    // Usar los valores existentes del item, no recalcular desde pricePurchase
    const unitPrice = Number(item.unitPrice) || 0;
    const quantity = Number(item.quantityOrdered) || 0;
    const discountPercent = Number(item.percentageDiscount) || 0;

    let grossAmount,
        discountAmount,
        netAmount,
        taxableAmount,
        igvAmount,
        totalWithIgv;

    if (conditionIgv === "01") {
        // IGV Incluido: el precio unitario incluye IGV
        grossAmount = unitPrice * quantity;
        discountAmount = (grossAmount * discountPercent) / 100;
        netAmount = grossAmount - discountAmount;
        taxableAmount = netAmount / 1.18;
        igvAmount = netAmount - taxableAmount;
        totalWithIgv = netAmount;
    } else {
        // IGV Aparte: el precio unitario NO incluye IGV
        grossAmount = unitPrice * quantity;
        discountAmount = (grossAmount * discountPercent) / 100;
        netAmount = grossAmount - discountAmount;
        taxableAmount = netAmount;
        igvAmount = taxableAmount * 0.18;
        totalWithIgv = netAmount + igvAmount;
    }

    return {
        ...item,
        unitPrice: unitPrice.toFixed(6),
        grossAmount: grossAmount.toFixed(2),
        discountAmount: discountAmount.toFixed(2),
        netAmount: netAmount.toFixed(2),
        taxableAmount: taxableAmount.toFixed(2),
        igvAmount: igvAmount.toFixed(2),
        totalWithIgv: totalWithIgv.toFixed(2),
        conditionIgv: conditionIgv,
        freeAmount: item.isFree ? netAmount.toFixed(2) : 0,
    };
}

export function recalculateAllItems(order) {
    return {
        ...order,
        operationItems: order.operationItems.map((item) =>
            recalculateItem(item, order.conditionIgv),
        ),
    };
}
